import Vue from "vue"
export default {
  methods: {
    formatDate(date, type) {
      if (!date) return ''
      let format = type === 'accredit' ? 'MM月dd日' : 'yyyy.MM.dd'
      return new Date(date.replace(/-/g, "/")).format(format)
    },
    formatDateToYMD(time){
      // 创建一个Date对象
    const date = new Date(time);
    // 获取年、月、日、时、分、秒
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 月份从0开始，所以需要加1
    const day = date.getDate();
    // 格式化为年月日时分秒字符串
    const formattedDateTime = `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")} `;
    return formattedDateTime;
    }
  }
}